import * as React from "react";
import { AppLayout, Box, Grid } from "@amzn/awsui-components-console";
import Tabs from "@amzn/awsui-components-console/tabs";
import { Navigation } from "../../commons/navBar";
import { gridDefinition } from '../../commons/layout';
import { DeprecationMessage } from "../infoPage/deprecationMessage";



const Content = () => {
    return <Box padding={{ vertical: 'xxl', horizontal: 's' }}>
        <Grid
            gridDefinition={[
                gridDefinition
            ]}
        >
            <Tabs
                tabs={[
                    {
                        label: "Scan CVE(s)",
                        id: "0",
                        content: <DeprecationMessage />
                    },
                    {
                        label: "Scan Security Tickets",
                        id: "1",
                        disabled: true,
                        content: <DeprecationMessage />
                    },
                    {
                        label: "Upload a Patch File",
                        id: "2",
                        disabled: true,
                        content: <DeprecationMessage />,
                    }
                ]}
                variant="container"
            />
        </Grid>
    </Box>
}

export function ScanPage() {
    const [navigationOpen, setNavigationOpen] = React.useState(true);

    return (
        <AppLayout
            headerSelector="#h"
            disableContentPaddings={true}
            content={<Content />}
            navigation={<Navigation activeHref="/scan" />}
            navigationOpen={navigationOpen}
            navigationWidth={200}
            onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
            toolsHide={true}
        />
    );
}